export const normalizePhoneNumber = (value: string): string => {
  let cleaned = value.replace(/\D/g, '');

  if (cleaned.startsWith('1') && cleaned.length === 11) {
    cleaned = cleaned.slice(1);
  }

  return cleaned.slice(0, 10);
};

export const formatPhoneNumber = (value: string): string => {
  const cleaned = normalizePhoneNumber(value);

  if (cleaned.length < 1) {
    return '';
  } else if (cleaned.length <= 3) {
    return `(${cleaned}`;
  } else if (cleaned.length <= 6) {
    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3)}`;
  }

  return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6, 10)}`;
};
